
import React from 'react';

interface BreathingInstructionsProps {
  isMobile: boolean;
}

const BreathingInstructions: React.FC<BreathingInstructionsProps> = ({ isMobile }) => {
  return (
    <div 
      className={`text-center ${isMobile ? 'px-2 py-2' : 'px-4 py-3'} bg-blue-100 rounded-lg max-w-md mx-auto shadow-sm`}
      role="region"
      aria-label="Breathing exercise instructions"
      tabIndex={0}
    >
      <p className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-700`}>
        Follow the breathing pattern: <span className="font-semibold">inhale for 4 seconds</span>, 
        <span className="font-semibold"> hold for 4 seconds</span>, 
        <span className="font-semibold"> exhale for 4 seconds</span>.
        <br />
        Continue this rhythm to help reduce stress and anxiety.
      </p>
    </div>
  );
};

export default React.memo(BreathingInstructions);
